import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
  {
    id       : 'applications',
    title    : 'Applications',
    translate: 'NAV.APPLICATIONS',
    type     : 'group',
    hidden   : false,
    children : [
      {
        id       : 'certificar',
        title    : 'Certificar',
        translate: 'NAV.CERTIFICAR.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        // url      : '/certify',
        hidden   : true,
        children : [
          {
            id        : 'certify_0',
            title     : 'certify_0',
            translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.0',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify',
            hidden    : true
          },
          {
            id        : 'certify_1',
            title     : 'certify_1',
            translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.1',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify_t1',
            hidden    : true
          },
          {
            id        : 'certify_2',
            title     : 'certify_2',
            translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.2',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify_t2',
            hidden    : true
          },
          {
            id        : 'certify_3',
            title     : 'certify_3',
            translate:  'NAV.CERTIFICAR.SUBPRODUCTOS.3',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify_t3',
            hidden    : true
          },
          {
            id        : 'certify_4',
            title     : 'certify_4',
            translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.4',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify_t4',
            hidden    : true
          },
          {
            id        : 'certify_6',
            title     : 'certify_6',
            translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.6',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/certify_t6',
            hidden    : true
          },
        ]
      },
      {
        id       : 'medir',
        title    : 'Medir',
        translate: 'NAV.MEDIR.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id        : 'medir_0',
            title     : 'medir_0',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.0',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement',
            hidden    : true
          },
          {
            id        : 'medir_1',
            title     : 'medir_1',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.1',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t1',
            hidden    : true
          },
          {
            id        : 'medir_2',
            title     : 'medir_2',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.2',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t2',
            hidden    : true
          },
          {
            id        : 'medir_3',
            title     : 'medir_3',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.3',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t3',
            hidden    : true
          },
          {
            id        : 'medir_4',
            title     : 'medir_4',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.4',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t4',
            hidden    : true
          },
          {
            id        : 'medir_5',
            title     : 'medir_5',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.5',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t5',
            hidden    : true
          },
          {
            id        : 'medir_6',
            title     : 'medir_6',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.6',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t6',
            hidden    : true
          },
          {
            id        : 'medir_7',
            title     : 'medir_7',
            translate: 'NAV.MEDIR.SUBPRODUCTOS.7',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/measurement_t7',
            hidden    : true
          },
        ]
      },
      {
        id        : 'medir_AMCO',
        title     : 'ICI',
        translate: 'NAV.MEDIR.SUBPRODUCTOS.8',
        type      : 'item',
        icon      : 'keyboard_arrow_right',
        url       : '/measurement_t8',
        hidden    : true
      },
      {
        id        : 'medir_INNO',
        title     : 'Innovation survey',
        translate: 'NAV.medir_INNO.TITULO',
        type      : 'item',
        icon      : 'keyboard_arrow_right',
        url       : '/measurement_t9',
        hidden    : true
      },
      {
        id       : 'pulse',
        title    : 'Pulse Check',
        translate: 'NAV.PULSE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id        : 'pulse_0',
            title     : 'pulse_0',
            translate: 'NAV.PULSE.SUBPRODUCTOS.0',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/pulse',
            hidden    : true
          },
          {
            id        : 'pulse_1',
            title     : 'pulse_1',
            translate: 'NAV.PULSE.SUBPRODUCTOS.1',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/pulse_t1',
            hidden    : true
          }
        ]
      },
      {
        id       : 'focus',
        title    : 'Focus Area',
        translate: 'NAV.FOCUS.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/focus',
        hidden   : true
      },
      {
        id       : 'focus1',
        title    : 'Focus Area',
        translate: 'NAV.FOCUS.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/focus_t1',
        hidden   : true
      },
      {
        id       : 'certificarN35',
        title    : 'Norma 035 ',
        translate: 'NAV.NORMA35.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'certificarN35_No',
            title    : 'Norma 035 ',
            translate: 'NAV.NORMA35.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/NOM35',
            hidden   : true
          },
          {
            id        : 'certificarN35_Bet',
            title     : 'Norma 035 betther',
            translate: 'NAV.NOM35BETHE.TITULO',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/NOM35-BETTHER',
            hidden    : true
          },
          {
            id        : 'certificarN35_Pla',
            title     : 'Norma 035 Plata',
            translate: 'NAV.NOM35PLA.TITULO',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/NOM35-PLATA',
            hidden    : true
          },
          {
            id        : 'certificarN35V3',
            title     : 'Norma 035 V3',
            translate: 'NAV.NOM35V3.TITULO',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/NOM35-v3',
            hidden    : true
          }
        ]
      },
      // {
      //   id       : 'certificarN35',
      //   title    : 'Norma 035 ',
      //   translate: 'NAV.NORMA35.TITULO',
      //   type     : 'item',
      //   icon     : 'check_box',
      //   url      : '/NOM35',
      //   hidden   : true
      //
      //
      // },
      //culture Audit
      {
        id       : 'Culture',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/Culture',
        hidden   : true


      },
      //culture Audit 2
      {
        id       : 'Culture_v2',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE2.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/cultureAudit',
        hidden   : true
      },
      //culture Audit training
      {
        id       : 'Culture_tra',
        title    : 'Culture Audit Training',
        translate: 'NAV.CATR.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/ca-training',
        hidden   : true
      },
      //Feedback
      {
        id       : 'Feedback',
        title    : 'Feedback',
        translate: 'NAV.FEEDBACK.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/feedback',
        hidden   : true


      },
      {
        id       : 'cloud',
        title    : 'cloud',
        translate: 'NAV.CLOUD.TITULO',
        type     : 'item',
        icon     : 'insert_drive_file',
        url      : '/file-manager',
        hidden   : true
      },
      {
        id       : 'file-server',
        title    : 'file-server',
        translate: 'NAV.CLOUD.TITULO',
        type     : 'item',
        icon     : 'insert_drive_file',
        url      : '/file-server',
        hidden   : true
      },
      {
        id       : 'noProds',
        title    : 'You have no products',
        translate: 'NAV.NOPRODUCTOS.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/products',
        hidden   : true
      },
      //4all resultados 2019
      {
        id       : 'forall',
        title    : 'forall resultados',
        translate: '4all resultados',
        type     : 'item',
        icon     : 'check_box',
        url      : '/forallResultados',
        hidden   : true
      },
      {// Herramienta temporal, aún no es seguro
        id       : '35encuesta',
        title    : '35encuesta',
        translate: 'NAV.ENCUESTA.TITULO',
        type     : 'item',
        icon     : 'people_alt',
        url      : 'NOM35/colaboradores-encuesta',
        hidden   : true
      },
      {
        id       : 'Culture_TR',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_TR1',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURETURQUIA1.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_tr1',
            hidden   : true
          },{
            id       : 'Culture_TR2',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURETURQUIA2.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_tr2',
            hidden   : true
          },{
            id       : 'Culture_TR3',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURETURQUIA3.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_tr3',
            hidden   : true
          }
        ]
      },
      {
        id       : 'Culture_TR_VOZEL',
        title    : 'Ozel Liste',
        translate: 'NAV.CULTURE_OZEL.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_Ozel_TR1',
            title    : 'Sosyal Sorumluluk',
            translate: 'NAV.Culture_Ozel_TR1.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_Ozel_tr1',
            hidden   : true
          }
        ]
      },
      {
        id       : 'Culture_MX',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_MX1',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX1.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX1',
            hidden   : true
          },{
            id       : 'Culture_MX2',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX2.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX2',
            hidden   : true
          },{
            id       : 'Culture_MX3',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX3.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX3',
            hidden   : true
          },{
            id       : 'Culture_MX4',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX4.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX4',
            hidden   : true
          },{
            id       : 'Culture_MX5',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX5.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX5',
            hidden   : true
          },{
            id       : 'Culture_MX6',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX6.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX6',
            hidden   : true
          },{
            id       : 'Culture_MX7',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX7.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX7',
            hidden   : true
          },{
            id       : 'Culture_MX8',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX8.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX8',
            hidden   : true
          },{
            id       : 'Culture_MX9',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX9.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX9',
            hidden   : true
          },{
            id       : 'Culture_MX10',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX10.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX10',
            hidden   : true
          },
          {
            id       : 'Culture_MX11',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX11.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX11',
            hidden   : true
          },
          {
            id       : 'Culture_MX12',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX12.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX12',
            hidden   : true
          },
          {
            id       : 'Culture_MX13',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREMX13.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX13',
            hidden   : true
          },
          {
            id       : 'Culture_MX14',
            title    : 'Cultuur Audit® CA&C',
            translate: 'NAV.CULTUREMX14.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX14',
            hidden   : true
          },
          {
            id       : 'Culture_MX15',
            title    : 'Culture Brief (certificar) 2022',
            translate: 'NAV.CULTUREMX15.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX15',
            hidden   : true
          },
          {
            id       : 'Culture_MX16',
            title    : 'Culture Audit (certificar, rkg.)',
            translate: 'NAV.CULTUREMX16.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX16',
            hidden   : true
          },
          {
            id       : 'Culture_MX17',
            title    : 'Culture Audit (certificar, rkg. y adic.)',
            translate: 'NAV.CULTUREMX17.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX17',
            hidden   : true
          },
          {
            id       : 'Culture_MX18',
            title    : 'Culture Audit (certificar, rkg. y adic.) 2023',
            translate: 'NAV.CULTUREMX18.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX18',
            hidden   : true
          },
          {
            id       : 'Culture_MX19',
            title    : 'Culture Brief (certificar) 2023',
            translate: 'NAV.CULTUREMX19.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX19',
            hidden   : true
          },
          {
            id       : 'Culture_MX20',
            title    : 'Culture Audit (certificar y ranking) 2023',
            translate: 'NAV.CULTUREMX20.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_MX20',
            hidden   : true
          },
        ]
      },
      {
        id       : 'Culture_CH',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_CH1',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURECH1.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_ch1',
            hidden   : true
          },{
            id       : 'Culture_CH2',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURECH2.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_ch2',
            hidden   : true
          },{
            id       : 'Culture_CH3',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURECH3.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_ch3',
            hidden   : true
          },{
            id       : 'Culture_CH4',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURECH4.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_ch4',
            hidden   : true
          },{
            id       : 'Culture_CH5',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURECH5.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_ch5',
            hidden   : true
          },
        ]
      },
      {
        id       : 'Culture_ES',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_ES1',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREESP1.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_esp1',
            hidden   : true
          },{
            id       : 'Culture_ES2',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREESP2.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_esp2',
            hidden   : true
          },{
            id       : 'Culture_ES3',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREESP3.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_esp3',
            hidden   : true
          },

        ]
      },
      {
        id       : 'Culture_CAYC',
        title    : 'Culture Audit',
        translate: 'NAV.CULTURE.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children : [
          {
            id       : 'Culture_Brief',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREBRI.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/Culture_Brief',
            hidden   : true
          },
          {
            id       : 'Culture_AuditCAYC',
            title    : 'Culture Audit',
            translate: 'NAV.CULTUREAUDI.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/Culture_Audit',
            hidden   : true
          },
          {
            id       : 'Culture_Brief_Culture_Audit',
            title    : 'Culture_Brief + Culture Audit',
            translate: 'NAV.CULTUREBRIEFAUDI.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/Culture_Brief_Culture_Audit',
            hidden   : true
          }
        ]
      },
      { //action
        id       : 'Culture_AP',
        title    : 'Action plan',
        translate: 'NAV.CULTUREESP3.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        hidden   : true,
        children:[
          {
            id       : 'Culture_AP1',
            title    : 'Action Plan',
            translate: 'NAV.CULTUREESP3.TITULO',
            type     : 'item',
            icon     : 'check_box',
            url      : '/culture_esp3',
            hidden   : true
          }
        ]
      },
      { //ICCA
        id       : 'Culture_AMCO',
        title    : 'ICCA',
        translate: 'NAV.CULTUREAMCO.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/icca',
        hidden   : true

        // type     : 'collapsable',
        // icon     : 'check_box',
        // hidden   : true,
        // children:[
        //   {
        //     id       : 'Culture_AP1',
        //     title    : 'Action Plan',
        //     translate: 'NAV.CULTUREESP3.TITULO',
        //     type     : 'item',
        //     icon     : 'check_box',
        //     url      : '/culture_esp3',
        //     hidden   : true
        //   }
        // ]
      },
      {
        id       : 'leaderGOAdmin',
        title    : 'leader GO® Administrador',
        translate: 'NAV.LEADERGOADMIN.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/leader_GO®_admin',
        hidden   : true
      },
      {
        id       : 'leaderGO',
        title    : 'leaderGO',
        translate: 'NAV.LEADERGOUSER.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/leader_GO®',
        hidden   : true
      },
      {
        id       : 'actionGoAdmin',
        title    : 'Action GO® Administrador',
        translate: 'NAV.ACTIONGOADMIN.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/actionGo_admin',
        hidden   : true
      },
      {
        id       : 'actionGO',
        title    : 'Action GO®',
        translate: 'NAV.ACTIONGO.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/action_GO',
        hidden   : true
      },
      {
        id       : 'certiAmco',
        title    : 'Certificaciones adicionales',
        translate: 'NAV.ENCUESTAS.TITULO',
        type     : 'collapsable',
        icon     : 'check_box',
        // url      : '/certify',
        hidden   : true,
        children : [
          {
            id        : 'amco',
            title     : 'AMCO',
            translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.0',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/amco_1',
            hidden    : true
          },
          {
            id        : 'traba_digno',
            title     : 'Trabajo digno',
            translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.1',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/traba_digno',
            hidden    : true
          },
          {
            id        : 'prime_emple',
            title     : 'Primer empleo',
            translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.2',
            type      : 'item',
            icon      : 'keyboard_arrow_right',
            url       : '/prime_emple',
            hidden    : true
          },
        ]
      },
      {
        id       : 'cultureICCA',
        title    : 'ICCA',
        translate: 'NAV.CULTUREAMCO.TITULO',
        type     : 'item',
        icon     : 'check_box',
        url      : '/culture_ICCA',
        hidden   : true
      },
    ]
  },
  {
    id       : 'tools',
    title    : 'tools',
    translate: 'NAV.TOOLS.TITULO',
    type     : 'group',
    hidden   : false,
    children : [
      {
        id       : 'chat',
        title    : 'chat',
        translate: 'NAV.TOOLS.CHAT',
        type     : 'item',
        icon     : 'message',
        url      : '/chat',
        hidden   : true
      },
      {
        id       : 'todo',
        title    : 'todo',
        translate: 'NAV.TOOLS.TODO',
        type     : 'item',
        icon     : 'list_alt',
        url      : '/all',
        hidden   : true
      },
      {
        id       : 'ods',
        title    : 'prueba ods',
        translate: 'NAV.PROFILECREATOR.TITULO',
        type     : 'item',
        icon     : 'person_add',
        url      : '/profile-creator',
        hidden   : true
      },
      {
        id       : 'perfs',
        title    : 'perfiles',
        translate: 'NAV.PROFILELIST.TITULO',
        type     : 'item',
        icon     : 'domain',
        url      : '/companies',
        hidden   : true
      },
      { // requerimientos MX
        id       : 'requirementsdetailMX',
        title    : 'requerimientos',
        translate: 'NAV.REQTEC.TITULO',
        type     : 'collapsable',
        icon     : 'domain',
        // url      : '/requirements-detail',
        hidden   : true,
        children : [
              {
                id        : 'certify_0_RT',
                title     : 'certify_0_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.0',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_0',
                hidden    : true
              },
              {
                id        : 'certify_1_RT',
                title     : 'certify_1_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.1',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_1',
                hidden    : true
              },
              {
                id        : 'certify_2_RT',
                title     : 'certify_2_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.2',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_2',
                hidden    : true
              },
              {
                id        : 'certify_3_RT',
                title     : 'certify_3_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.3',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_3',
                hidden    : true
              },
              {
                id        : 'certify_4_RT',
                title     : 'certify_4_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.4',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_4',
                hidden    : true
              },
              {
                id        : 'certify_6_RT',
                title     : 'certify_6_RT',
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.6',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingcertify_6',
                hidden    : true
              },
              {
                id        : 'medir_0_RT',
                title     : 'medir_0_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.0',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement',
                hidden    : true
              },
              {
                id        : 'medir_1_RT',
                title     : 'medir_1_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.1',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t1',
                hidden    : true
              },
              {
                id        : 'medir_2_RT',
                title     : 'medir_2_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.2',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t2',
                hidden    : true
              },
              {
                id        : 'medir_3_RT',
                title     : 'medir_3_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.3',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t3',
                hidden    : true
              },
              {
                id        : 'medir_4_RT',
                title     : 'medir_4_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.4',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t4',
                hidden    : true
              },
              {
                id        : 'medir_5_RT',
                title     : 'medir_5_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.5',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t5',
                hidden    : true
              },
              {
                id        : 'medir_6_RT',
                title     : 'medir_6_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.6',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t6',
                hidden    : true
              },
              {
                id        : 'medir_7_RT',
                title     : 'medir_7_RT',
                translate: 'NAV.MEDIR.SUBPRODUCTOS.7',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t7',
                hidden    : true
              },
              {
                id        : 'medir_8_RT',
                title     : 'Innovation survey',
                translate: 'Innovation survey',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingmeasurement_t7',
                hidden    : true
              },
          {
            id       : 'pulse_RT',
            title    : 'Pulse Check',
            translate: 'NAV.PULSE.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/requerimentsLandingPulse',
            hidden   : true
          },
          {
            id       : 'pulse_t1_RT',
            title    : 'Pulse Check',
            translate: 'NAV.PULSE.SUBPRODUCTOS.1',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/requerimentsLandingPulse_t1',
            hidden   : true
          },
          {
            id       : 'focus_RT',
            title    : 'Focus Area',
            translate: 'NAV.FOCUS.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/requerimentsLandingfocus',
            hidden   : true
          },
          {
            id       : 'certificarN35_RT',
            title    : 'Norma 035 ',
            translate: 'NAV.NORMA35.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/requirements-detail',
            hidden   : true


          },
          {
            id       : 'certificarN35V3_RT',
            title    : 'Norma 035 ',
            translate: 'NAV.NOM35V3.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/requerimentsLandingNom35',
            hidden   : true


          },
          //culture Audit
          {
            id       : 'Culture_RT',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURE.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/Culture',
            hidden   : true


          },
          //culture Audit 2
          {
            id       : 'Culture_v2_RT',
            title    : 'Culture Audit',
            translate: 'NAV.CULTURE2.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/cultureAudit',
            hidden   : true
          },
          //culture Audit training
          {
            id       : 'Culture_tra_RT',
            title    : 'Culture Audit Training',
            translate: 'NAV.CATR.TITULO',
            type     : 'item',
            icon     : 'keyboard_arrow_right',
            url      : '/ca-training',
            hidden   : true
          },
          {
                id        : 'amco_RT',
                title     : 'AMCO',
                translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.0',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingamco_1',
                hidden    : true
              },
              {
                id        : 'traba_digno_RT',
                title     : 'Trabajo digno',
                translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.1',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingtraba_digno',
                hidden    : true
              },
              {
                id        : 'prime_emple_RT',
                title     : 'Primer empleo',
                translate: 'NAV.ENCUESTAS.SUBPRODUCTOS.2',
                type      : 'item',
                icon      : 'keyboard_arrow_right',
                url       : '/requerimentsLandingprimer_emple',
                hidden    : true
              },
        ]

      },
      { //Boton  acercade
        id       : 'about',
        title    : 'about',
        translate: 'NAV.ABOUT.TITULO',
        type     : 'item',
        icon     : 'history',
        // icon     : 'contact_support',
        url      : '/about',
        hidden   : true
      },
      {
        id       : 'questions',
        title    : 'questions',
        translate: 'NAV.QUESTIONS.TITULO',
        type     : 'item',
        icon     : 'help_outline',
        url      : '/preguntas-frecuentes',
        hidden   : true
      },
      {
        id       : 'videos_inst',
        title    : 'videos',
        translate: 'NAV.VIDEOS.TITULO',
        type     : 'item',
        icon     : 'video_label',
        url      : '/videos-institucionales',
        hidden   : true
      },
      {  //Consultar encuesta
        id       : 'consultarEncuesta',
        title    : 'consultarEncuesta',
        translate: 'NAV.CONSULTAR_E.TITULO',
        type     : 'item',
        icon     : 'assignment',
        url      : '/consult-survey',
        hidden   : true
      },
      {  //Consultar encuesta
        id       : 'calendSurvey',
        title    : 'calendSurvey',
        translate: 'NAV.CALEND_SUR.TITULO',
        type     : 'item',
        icon     : 'assignment',
        url      : '/calend-survey',
        hidden   : true
      },
      {  //Consultar encuesta
        id       : 'controlEncuesta',
        title    : 'controlEncuesta',
        translate: 'NAV.CONTROL_SURVE.TITULO',
        type     : 'item',
        icon     : 'control_camera',
        url      : '/consultar/controlEncuesta',
        hidden   : true
      },
      {  //Encuesta Generica
        id       : 'genericSurvey',
        title    : 'surveyGeneric',
        translate: 'NAV.SURVEY_GENERIC.TITULO',
        type     : 'item',
        icon     : 'list_alt',
        url      : '/survey-generic',
        hidden   : true
      },
      {  //consultar raw data
        id       : 'rawdataFinder',
        title    : 'rawdataFinder',
        translate: 'NAV.RAWDATA_FINDER.TITULO',
        type     : 'item',
        icon     : 'assignment',
        url      : '/rawdata/find',
        hidden   : true
      },
      {
        id       : 'videos_admin',
        title    : 'videos',
        translate: 'NAV.VIDEOSADMIN.TITULO',
        type     : 'item',
        icon     : 'video_label',
        url      : '/videos-administrador',
        hidden   : true
      },
      {  //Auditoria Automatizada
        id       : 'auditoriaAutomatizada',
        title    : 'auditoriaAutomatizada',
        translate: 'NAV.AUDITORIA-AUTO.TITULO',
        type     : 'item',
        icon     : 'assignment_ind',
        url      : '/auditoria/auditoriaAutomatizada',
        hidden   : true
      },
      {
        id       : 'videos_tips',
        title    : 'videos',
        translate: 'NAV.TIPS.TITULO',
        type     : 'item',
        icon     : 'video_label',
        url      : '/norma-tips',
        hidden   : true
      },
      {
        id       : 'log',
        title    : 'log',
        translate: 'NAV.LOG_SISTEMA.TITULO',
        type     : 'item',
        icon     : 'build',
        url      : '/log-sistema',
        hidden   : true
      },
      {
        id       : 'requirementsdetail',
        title    : 'requerimientos',
        translate: 'NAV.REQTEC.TITULO',
        type     : 'item',
        icon     : 'domain',
        url      : '/requirements-details',
        hidden   : true,
      },
      {
        id       : 'consultarRequerimientos',
        title    : 'consultarRequerimientos',
        translate: 'NAV.CONSUL_REQUE.TITULO',
        type     : 'item',
        icon     : 'assignment_turned_in',
        url      : '/consultar-Requerimientos',
        hidden   : true,
      },
      {
        id       : 'editorBroker',
        title    : 'editorBroker',
        translate: 'NAV.TOOLS.BROKER',
        type     : 'item',
        icon     : 'admin_panel_settings',
        url      : '/broker-configuration',
        hidden   : true,
      },
      {
        id       : 'changelog',
        title    : 'changelog',
        translate: 'NAV.TOOLS.CHANGELOG',
        type     : 'item',
        icon     : 'history',
        url      : '/changelog',
        badge: {
            title: '',
            bg   : '#FFFFFF',
            fg   : '#343940'
        },
        hidden   : true,
      },
      {
        id       : 'knowledge-base',
        title    : 'knowledge-base',
        translate: 'NAV.TOOLS.KNOWLEDGE',
        type     : 'item',
        icon     : 'school',
        url      : '/knowledge-base',
        hidden   : true,
      },
      {
        id       : 'web-company-profile',
        title    : 'web-company-profile',
        translate: 'NAV.TOOLS.WEB_COM_PROF',
        type     : 'item',
        icon     : 'business',
        url      : '/web/company_profile',
        hidden   : true,
      },
    ]
  },
  {
    id       : 'results',
    title    : 'Results',
    translate: 'NAV.RESULTS.TITULO',
    type     : 'group',
    hidden   : true,
    children : [
      {
        id       : 'ti',
        title    : 'ti',
        translate: 'NAV.RESULTS.ENLACES.TI',
        type     : 'item', //collapsable
        icon     : 'bar_chart',
        url      : '/results/trust_index'
      },
      {
        id       : 'ti_5',
        title    : 'ti',
        translate: 'NAV.RESULTS.ENLACES5.TI',
        type     : 'item', //collapsable
        icon     : 'bar_chart',
        url      : 'results/results5.0'
      },
      {
        id       : 'actionGo',
        title    : 'ActionGo',
        translate: 'NAV.RESULTS.ENLACES_ACTION_GO.TITULO',
        type     : 'item', //collapsable
        icon     : 'donut_small',
        url      : 'results/actionGO'
      },
      {
        id       : 'actionGoLevel13', //usuario nivel 13 actiongo
        title    : 'ActionGo',
        translate: 'NAV.RESULTS.ENLACES_ACTION_GO.TITULO',
        type     : 'item', //collapsable
        icon     : 'donut_small',
        url      : 'actionGO/'
      },
      {
        id       : 'actionGoAdminLider', //usuario nivel 14 actiongo
        title    : 'ActionGo',
        translate: 'NAV.RESULTS.ENLACES_ACTION_GO.TITULO',
        type     : 'item', //collapsable
        icon     : 'donut_small',
        url      : '/actionGoAdminLider'
        // url      : 'results/actionGO'
      },
      {
        id       : 'actionGoLevel12', //usuario nivel 14 actiongo
        title    : 'ActionGo',
        translate: 'NAV.RESULTS.ENLACES_ACTION_GO.TITULO',
        type     : 'item', //collapsable
        icon     : 'donut_small',
        url      : 'actionGO/'
        // url      : 'results/actionGO'
      },
      {
        id       : 'ti_goFlow',
        title    : 'ti',
        translate: 'NAV.RESULTS.ENLACES_GO_FLOW.TITULO',
        type     : 'item',
        icon     : 'donut_small',
        url      : '/results/goFlow'
      }
    ]
  },
  {
    id       : 'resultsCovid',
    title    : 'Results',
    translate: 'NAV.RESULTS.TITULO',
    type     : 'group',
    hidden   : true,
    children : [
      {
        id       : 'ti_covid',
        title    : 'ti',
        translate: 'NAV.RESULTS.ENLACES.COVID',
        type     : 'item',
        icon     : 'bar_chart',
        url      : '/results/covid'
      }
    ]
  },
];
